export { default as FourHundredError } from './FourHundredError';
export type { Props as FourHundredErrorProps } from './FourHundredError';
export { default as FourHundredErrorPage } from './FourHundredErrorPage';
